import { render, staticRenderFns } from "./AppStudyBar.vue?vue&type=template&id=42aaca86&"
import script from "./AppStudyBar.vue?vue&type=script&lang=js&"
export * from "./AppStudyBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports